import { createContext, useContext } from 'react';
import { Stage } from 'api/contentworkflow/publishing-board';

export interface StageGateConfig {
    showInconsistencies: boolean;
    showClarifications: boolean;
    requiresInconsistencies: boolean;
    requiresClarifications: boolean;
}

// Fallback when the form is rendered outside the Publishing Board (no stage context):
// both cards visible, nothing gates the move — the pre-gating behavior.
export const defaultStageGateConfig: StageGateConfig = {
    showInconsistencies: true,
    showClarifications: true,
    requiresInconsistencies: false,
    requiresClarifications: false,
};

export function stageGateConfigFromStage(stage: Stage | null | undefined): StageGateConfig {
    if (!stage) {
        return defaultStageGateConfig;
    }

    // A required gate is always shown: otherwise Save & Move could be blocked by a gate the
    // user never sees.
    return {
        showInconsistencies:
            stage.inconsistency_gate_shown_ind === 'Y' || stage.inconsistency_gate_required_ind === 'Y',
        showClarifications: stage.clarification_gate_shown_ind === 'Y' || stage.clarification_gate_required_ind === 'Y',
        requiresInconsistencies: stage.inconsistency_gate_required_ind === 'Y',
        requiresClarifications: stage.clarification_gate_required_ind === 'Y',
    };
}

export const StageGateContext = createContext<StageGateConfig>(defaultStageGateConfig);

export const useStageGateConfig = () => useContext(StageGateContext);
